import React, { useEffect, useState } from "react";

import { IOnboardPageManager } from "../../services/nav/Interfaces";

interface IProps {
  pageManager: IOnboardPageManager;
}

export const StepProgress = ({ pageManager: pageConfig }: IProps) => {
  const [currentStep, setCurrentStep] = useState(-1);
  const totalSteps = pageConfig.stepTotal;

  useEffect(() => {
    setCurrentStep(pageConfig.stepNum);
  }, [pageConfig.stepNum]);

  const indicators = [];

  for (let i = 1; i <= totalSteps; i++) {
    const isCompleted = i < currentStep;
    const isCurrent = i === currentStep;
    const isLastStep = i === totalSteps;

    const circleColor = isCurrent
      ? isLastStep
        ? "bg-zeos-orange-dk" // Makes the last current step orange
        : "bg-zeos-blue"
      : isCompleted
      ? "bg-zeos-orange-dk"
      : "bg-zeos-grey-md";

    indicators.push(
      <div key={i} className="flex items-center flex-shrink-0">
        {/* Dot */}
        <div
          className={`w-[0.9rem] h-[0.9rem] rounded-full transition-colors duration-300 ${circleColor}`}
        ></div>

        {/* Connecting Line */}
        {i < totalSteps && (
          <div className="w-[5.5rem] h-[0.125rem] bg-zeos-grey-md transition-colors duration-300"></div>
        )}
      </div>
    );
  }

  return (
    <div className="flex items-center pl-20 pt-0">
      <div className="flex">{indicators}</div>
    </div>
  );
};
